import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, map, Observable, of, ReplaySubject, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { OPD_CONST } from '../../properties/opd-static-properties';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MASTERSSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/master-service';
import { CopDecimalCalculateService } from 'projects/lib/medcare-core-lib/src/lib/services/cop-decimal-calculate.service';
import { InfoDialogComponent } from 'projects/lib/medcare-core-lib/src/lib/core/info-dialog/info-dialog.component';
import { PatientNextOfKin } from 'projects/lib/medcare-core-lib/src/lib/services/RegistationModel';
import { PatientRegistrationService } from '../../services/Spatient-registration.service';
import { MasterUrlService } from '../../services/SmasterUrl.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiLanguageService } from 'projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service';
import { ConfirmDynamicDialogComponent } from 'projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component';
import { baseObj } from '../../interface/IerRegistration';

@Component({
  selector: 'app-kin-details-dialog',
  templateUrl: './kin-details-dialog.component.html',
  styleUrls: ['./kin-details-dialog.component.scss']
})

export class KinDetailsDialogComponent implements OnInit, OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  private subscriptionList = new Subscription();
  protected _onDestroy = new Subject<void>();
  displayedColumnsNextOfKinDetails: string[] = OPD_CONST.displayedColumnsNextOfKinDetails;
  displayedColumnsViewNokDetails: string[] = OPD_CONST.displayedColumnsViewNokDetails;
  dataSourceNextOfKin: MatTableDataSource<any> = new MatTableDataSource<any>();
  dataSourceViewNokDetails: MatTableDataSource<any> = new MatTableDataSource<any>();
  ElementNextofKin: any[] = [];
  selectedTabIndex = 0;
  masterAPI: any = MASTERSSERVICES;
  formNextOfKin: FormGroup;
  nokCountryCode: any = null;
  nokStateCode: any = null;
  nokCityCode: any = null;
  relationList: any[] = [];
  primaryIdList: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  newPrefixList: any[] = [];
  nokId: string = '';
  titleDefaultValue: string = "";
  relationDefaultValue: string = "";
  identificationTypeDefaultValue: string = "";
  countryDefaultValue: string = "";
  stateDefaultValue: string = "";
  cityDefaultValue: string = "";
  isEditNok: boolean = false;
  nokIid: number;
  allNOKList: any[] = [];
  primaryIdFilteredListNok: any[] = [];
  primaryIdSearchNok: FormControl = new FormControl();
  nokAreaCode: baseObj;
  subDistrictAreaList: baseObj[];
  areaDefaultValue: string = "";
  // unitCode: string;
  // orgCode: string;
  constructor(
    public dialogRef: MatDialogRef<KinDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private appBaseService: AppBaseService,
    private formBuilder: FormBuilder,
    public inputValidation: CopDecimalCalculateService,
    public dialog: MatDialog,
    private patientRegService: PatientRegistrationService,
    public masterApiService: MasterUrlService,
    private snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    // private authService:AuthService
  ) {
    this.getRelationList();
    this.getPrimaryIdList();
    this.getCountryList();
    this.getPrefixList();
  }

  ngOnInit(): void {
    this.formNextOfKin = this.formBuilder.group({
      prefix: [""],
      name: ["", Validators.required],
      identificationType: [""],
      identificationNumber: [""],
      relation: [""],
      phoneNumber: [""],
      isGuarantor: [""],
      address: [""],
      country: [""],
      state: [""],
      city: [""],
      area: [""],
      postcode: [""],
    });
    this.getNextOfKinDetails(this.data);
    this.getNOKOtherList(this.data);

    // this.onchange();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
  }

  onchange() {
    this.subscriptionList.add(
      this.formNextOfKin.controls["state"].valueChanges.subscribe((val) => {
        this.getNOKCityList(val);
      })
    );
    this.subscriptionList.add(
      this.formNextOfKin.controls["country"].valueChanges.subscribe((val) => {
        this.getNOKStateList(val);
      })
    );
    this.subscriptionList.add(
      this.formNextOfKin.controls["city"].valueChanges.subscribe((val) => {
        this.getSubDistrictForNOK(val);
      })
    );    
    this.subscriptionList.add(
      this.primaryIdSearchNok.valueChanges.subscribe((value) => {
        this.primaryIdFilteredListNok = this.primaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }
  /**
   * closing dialog
   */
  onClick() {
    this.dialogRef.close();
  }
  //    getUnitData() {
  //     this.authService.getUnit().then((value: any) => {
  //       this.unitCode = value.unitCode;
  //       this.orgCode=value.orgCode;
  //       this.getAppConfigList();

  //     });
  //   }

  //  getAppConfigList() {
  //    let mrdConfig: any;
  //    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
  //    this.appBaseService
  //      .getResource("appConfiguration/findConfigByModule?unitCode=" + this.unitCode +
  //        "&orgCode=" + this.orgCode + "&moduleName=" + OPD_CONST.patientManagement + "&keyName=")
  //      .pipe(takeUntil(this._onDestroy))
  //      .subscribe((res) => {
  //        if (res) {
  //          mrdConfig = res.keys;
  //         mrdConfig.forEach((element) => {
  //            if (element.key == MasterKeys.defaultCountry){
  //             if (element.valueList.length > 0) {
  //               let defaultCountry =this.countryPrimaryList.find(i=>i.code==element.valueList[0].code) ;
  //               this.getNOKStateList(defaultCountry);
  //             }
  //           }
  //         })
  //       }
  //      })
  //     }
  getRelationList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_RELATION, true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.relationList = data;
      });
  }
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.primaryIdList = data.filter((i) => i.isPrimaryId);;
        this.primaryIdFilteredListNok = this.primaryIdList;
      });
  }
  getCountryList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COUNTRY, true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryPrimaryList = data;
      });
  }
  getPrefixList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_PREFIX, true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.newPrefixList = data;
      });
  }

  /**
   * 
   * @param rowData 
   */
getNextOfKinDetails(rowData) {
  this.data = rowData;
  this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
  this.appBaseService
    .getResource(OPD_API_URL.GET_KIN_DETAILS_LIST_BY_ENCOUNTER_ID + this.data.encounterId)
    .subscribe((response) => {
      const observables: Observable<PatientNextOfKin>[] = [];

      if (response) {
         response.forEach((element) => {
          if (element.active === true) {
            const nextOfKin: PatientNextOfKin = this.patientRegService.getNextOfKinValues(this, element);

            if (nextOfKin.country?.code) {
              const updatedKin$ = this.getNOKStateList1(nextOfKin.country.code, nextOfKin.state.code).pipe(
                switchMap((matchedState) => {
                  if (matchedState) {
                    nextOfKin.state.code = matchedState;
                    return this.getNOKCityList1(matchedState, nextOfKin.city.code);
                  } else {
                    return of(null);
                  }
                }),
                switchMap((matchedCity) => {
                  if (matchedCity) {
                    nextOfKin.city.code = matchedCity;
                    return this.getNOKAreaListForGet(matchedCity, nextOfKin.area.code);
                  } else {
                    return of(null);
                  }
                }),
                map((matchedArea) => {
                  if (matchedArea) {
                    nextOfKin.area.code = matchedArea;
                  }
                  return nextOfKin;
                })
              );
              observables.push(updatedKin$);
            } else {
              observables.push(of(nextOfKin));
            }
          }
        });

        if (observables.length > 0) {
          forkJoin(observables).subscribe((finalList: PatientNextOfKin[]) => {
            this.ElementNextofKin = finalList;
            this.dataSourceNextOfKin = new MatTableDataSource<any>(this.ElementNextofKin);
          });
        } else {
          this.ElementNextofKin = [];
          this.dataSourceNextOfKin = new MatTableDataSource<any>([]);
        }
      }
    });
}



 getNOKOtherList(data) {
  this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
  this.appBaseService
    .getResource(OPD_API_URL.GET_NOK_VIEW + "patientId=" + data.patientId + "&encounterId=" + data.encounterId)
    .subscribe((response) => {
      const observables: Observable<PatientNextOfKin>[] = [];

      if (response) {
         response.forEach((element) => {
          if (element.active === true) {
            const nextOfKin: PatientNextOfKin = this.patientRegService.getNextOfKinValues(this, element);

            if (nextOfKin.country?.code) {
              const updatedKin$ = this.getNOKStateList1(nextOfKin.country.code, nextOfKin.state.code).pipe(
                switchMap((matchedState) => {
                  if (matchedState) {
                    nextOfKin.state.code = matchedState;
                    return this.getNOKCityList1(matchedState, nextOfKin.city.code);
                  } else {
                    return of(null);
                  }
                }),
                switchMap((matchedCity) => {
                  if (matchedCity) {
                    nextOfKin.city.code = matchedCity;
                    return this.getNOKAreaListForGet(matchedCity, nextOfKin.area.code);
                  } else {
                    return of(null);
                  }
                }),
                map((matchedArea) => {
                  if (matchedArea) {
                    nextOfKin.area.code = matchedArea;
                  }
                  return nextOfKin;
                })
              );
              observables.push(updatedKin$);
            } else {
              observables.push(of(nextOfKin));
            }
          }
        });

        if (observables.length > 0) {
          forkJoin(observables).subscribe((finalList: PatientNextOfKin[]) => {
            this.allNOKList = finalList;
            this.dataSourceViewNokDetails = new MatTableDataSource<any>(this.allNOKList);
          });
        } else {
          this.allNOKList = [];
          this.dataSourceViewNokDetails = new MatTableDataSource<any>([]);
        }
      }
    });
}



  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }
  getNOKStateList(countryCode) {
    if (countryCode.id) {
      this.nokCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: countryCode.id,
      };

      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + countryCode.id)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.statePrimaryList = res;
          let state = this.statePrimaryList = this.statePrimaryList.filter(
            (item) => item.code === this.stateDefaultValue
          );
          this.getNOKCityList(state[0]);
        });
    }
  }
  getNOKStateList1(countryCode: any, statecode: string): Observable<any> {
    if(countryCode && countryCode.id){
    const url = OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + countryCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        if (statecode &&statecode) {
            return res.find(item => item.code === statecode);
          } else {
            return null;
          }
      })
    );}
  }


  getNOKCityList(cityCode) {
    if (cityCode.id) {
      this.nokStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: cityCode.id,
      };

      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + cityCode.id)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityPrimaryList = res;
            let city = this.cityPrimaryList = this.cityPrimaryList.filter(
            (item) => item.code === this.cityDefaultValue
          );
          this.getSubDistrictForNOK(city[0]);
        });
    }
  }
  getNOKCityList1(stateCode: any, cityCode: string): Observable<any> {
      if(stateCode && stateCode.id){
    const url = OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + stateCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
       map((res: any[]) => {
        if (cityCode) {
            return res.find(item => item.code === cityCode);
          } else {
            return null;
          }
      })
    );}
  }
getNOKAreaListForGet(cityCode: any, areaCode: string): Observable<any> {
  if (cityCode && cityCode.id) {
    const url = OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + cityCode.id;
    return this.masterApiService.getTypeMaster(url).pipe(
      takeUntil(this._onDestroy),
      map((res: any[]) => {
        if (areaCode) {
            return res.find(item => item.code === areaCode);
        } else {
          return null;
        }
      })
    );
  }
  return of(null);
}

  displayAddressDetails(element) {
    const address = element.address || '';
    const country = element.country?.desc || '';
    const state = element.state?.desc || '';
    const city = element.city?.desc || '';
    const postcode = element.postcode || '';
    const area = element.area?.desc || '';

    const fullAddress = [address, country, state, city,area, postcode]
      .filter(val => val)
      .join(', ');
    this.dialog.open(InfoDialogComponent, {
      width: "30%",
      data: {
        display: "Address Details",
        info: fullAddress
      }
    });
  }
  setGuarantorValue(selectedElement: any, event) {
    if (event.checked) {
      selectedElement.isGuarantor = true;
    } else {
      selectedElement.isGuarantor = false;
    }
    if (!selectedElement.isGuarantor) {
      const guarantorCount = this.ElementNextofKin.filter(item => item.isGuarantor).length;
      if (guarantorCount < 1) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.PleaseSelectGuarenter"),
          this.langService.get("CommonAppoinment.validation"),
          { duration: 2000 }
        );
      }
    }
  }
  editNOK(element) {
    this.selectedTabIndex = 0;
    this.isEditNok = true;
    this.nokId = element.id ? element.id : '';
    this.nokIid = element.iid ? element.iid : '';

    this.titleDefaultValue = element.prefix?.code?.code || "";
    this.relationDefaultValue = element.relation?.code?.code || "";
    this.identificationTypeDefaultValue = element.identificationType?.code?.code || "";
    this.countryDefaultValue = element.country?.code?.code || "";
    this.stateDefaultValue = element.state?.code?.code || "";
    this.areaDefaultValue = element.area?.code?.code || "";
    this.cityDefaultValue = element.city?.code?.code || "";

    if (element.country?.code) this.getNOKStateList(element.country?.code);

    this.formNextOfKin.patchValue({
      prefix: element.prefix?.code || "",
      name: element.name || "",
      identificationType: element.identificationType?.code || "",
      identificationNumber: element.idNumber || "",
      relation: element.relation?.code || "",
      phoneNumber: element.phoneNumber || "",
      isGuarantor: element.isGurantor || false,
      address: element.address || "",
      country: element.country?.code || "",
      state: element.state?.code || "",
      area: element.area?.code || "",
      city: element.city?.code || "",
      district: [""],
      postcode: element.postcode || "",
    });

  }
  validateNextOfKinForm(): boolean {
    for (var i in this.formNextOfKin.controls) {
      this.formNextOfKin.controls[i].markAsTouched();
    }
    return this.formNextOfKin.valid;
  }

  saveNextOfKin() {
    const allFalse = this.dataSourceNextOfKin.data.every(element => !element.isGuarantor);

    if (allFalse) {
      this.snackBar.open('Please select at least one guarantor.', 'error', { duration: 2000 });
      return;
    }

    if (this.dataSourceNextOfKin.data.length > 0) {
      this.dataSourceNextOfKin.data.forEach(item => {
        item.active = true;
      });

      let nextOfKin: any =
        this.patientRegService.getNextOfKinList(this.dataSourceNextOfKin.data);

      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Add Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let payload = {
              patientId: this.data.patientId,
              encounterId: this.data.encounterId,
              kinDetailsDTOList: nextOfKin
            };
            this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
            this.appBaseService
              .postResource(OPD_API_URL.NOK_SAVE_AND_UPDATE, payload)
              .subscribe((res) => {
                if (res.message) {
                  this.snackBar.open(res.message, "Success", {
                    duration: 2000
                  });
                  this.formNextOfKin.reset();
                  this.isEditNok = false;
                  this.onClick();
                }
              });
          }
        })
      )
    } else {
      this.snackBar.open('Please add at least one guarantor.', 'Validation', { duration: 2000 });
    }
    return this.formNextOfKin.controls["name"].valid;
  }
  addNextOfKin(value: string) {
    if (value && value.trim() === 'add') {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Add Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            if (this.validateNextOfKinForm()) {
              let nextOfKin: PatientNextOfKin =
                this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
              nextOfKin.checked = true;
              if (nextOfKin) {
                let list = this.dataSourceNextOfKin.data;
                list.push(nextOfKin);
                this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
                this.formNextOfKin.reset();
              }
            } else {
              this.snackBar.open(
                "Please fill all required fields",
                "Validation",
                { duration: 2000 }
              );
            }
          }
        })
      );
    } else {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Update Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {
            let nextOfKin: any =
              this.patientRegService.getNextOfKinFormValues(this, this.formNextOfKin);
            var index = this.dataSourceNextOfKin.data.findIndex(
              kin => kin?.iid === this.nokIid || kin?.id?.toString() === this.nokId
            );
            this.dataSourceNextOfKin.data.forEach((kin) => {
              if (kin.iid?.toString() === this.nokId) {
                nextOfKin.iid = this.nokIid;
              } else if (kin.id?.toString() === this.nokId) {
                nextOfKin.id = this.nokId;
              }
            });

            if (index !== -1) {
              this.dataSourceNextOfKin.data[index] = nextOfKin;
            } else {
              this.snackBar.open('No matching record found to replace', 'Validartion', {
                duration: 2000
              });
            }
            this.dataSourceNextOfKin._updateChangeSubscription();
            this.isEditNok = false;
            this.formNextOfKin.reset();
          }
        })
      );
    }
    return this.formNextOfKin.controls["name"].valid;
  }

  deleteNextOfKin(element) {
    if (element.id) {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "Do you want Delete Nok?" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result.confirm == "yes") {

            let id = element.id ? element.id : "";
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.subscriptionList.add(
              this.appBaseService
                .deleteResource(OPD_API_URL.DELETE_NOK_ + this.data.encounterId + "&nokId=" + id)
                .subscribe((res) => {
                  this.snackBar.open("Next of Kin Deleted", "Success", {
                    duration: 2000,
                  });
                  const index: number = this.ElementNextofKin.indexOf(element);

                  if (index != -1) {
                    this.ElementNextofKin.splice(index, 1);
                    this.dataSourceNextOfKin = new MatTableDataSource(this.ElementNextofKin);
                  }
                })
            );
          }
        })
      );
    } else {
      const index: number = this.dataSourceNextOfKin.data.indexOf(element);

      let list = this.dataSourceNextOfKin.data;
      list.splice(index, 1);
      this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
    }


  }
  addexistingNok(element) {
    const exists = this.dataSourceNextOfKin.data.some(kin => kin.id?.toString() === element.id);

    if (exists) {
      this.snackBar.open('NOK already exists', 'Validation', { duration: 2000 });
      return;
    }

    element.checked = true;

    const list = [...this.dataSourceNextOfKin.data, element];
    this.dataSourceNextOfKin = new MatTableDataSource<any>(list);
  }
    getSubDistrictForNOK(city) {
      if (city && city.id) {
        this.nokAreaCode = {
          field: OPD_API_URL.M_CITY_VALUE,
          value: city.id,
        };
      }
    }
  secondaryDistrictAreaSelected(event) {
    if (event.postCode)
      this.formNextOfKin.patchValue({
        postcode: event.postCode,
      });
  }
}

